if (!customElements.get('kiwibit-announcement-countdown')) {
  class KiwibitAnnouncementCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      delete this.dataset.expired;
      this.endTime = this.parseBeijingTime(this.dataset.endBeijing);
      this.values = {
        days: this.querySelector('[data-countdown-unit="days"]'),
        hours: this.querySelector('[data-countdown-unit="hours"]'),
        minutes: this.querySelector('[data-countdown-unit="minutes"]'),
        seconds: this.querySelector('[data-countdown-unit="seconds"]'),
      };

      this.update();

      if (this.endTime > Date.now()) {
        this.interval = window.setInterval(() => this.update(), 1000);
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    parseBeijingTime(value = '') {
      const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (!match) return 0;

      const year = Number(match[1]);
      const month = Number(match[2]);
      const day = Number(match[3]);
      const hour = Number(match[4]);
      const minute = Number(match[5]);
      const second = Number(match[6] || 0);
      const beijingOffset = 8 * 60 * 60 * 1000;
      const timestamp = Date.UTC(year, month - 1, day, hour, minute, second) - beijingOffset;
      const verification = new Date(timestamp + beijingOffset);

      const isValid =
        verification.getUTCFullYear() === year &&
        verification.getUTCMonth() === month - 1 &&
        verification.getUTCDate() === day &&
        verification.getUTCHours() === hour &&
        verification.getUTCMinutes() === minute &&
        verification.getUTCSeconds() === second;

      return isValid ? timestamp : 0;
    }

    update() {
      const remaining = Math.max(0, this.endTime - Date.now());
      const totalSeconds = Math.ceil(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.setValue('days', days);
      this.setValue('hours', hours);
      this.setValue('minutes', minutes);
      this.setValue('seconds', seconds);

      if (remaining === 0) {
        this.dataset.expired = 'true';
        this.stop();
      }
    }

    setValue(unit, value) {
      if (this.values[unit]) {
        this.values[unit].textContent = String(value).padStart(2, '0');
      }
    }

    stop() {
      if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }
  }

  customElements.define('kiwibit-announcement-countdown', KiwibitAnnouncementCountdown);
}
